import React, { useContext, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Icon from 'react-icons-kit';
import { activity, creditCard, logOut, search, user as userIcon, userCheck, users, zap } from 'react-icons-kit/feather';
import { useSelector } from 'react-redux';

import './indexStyle.scss';

import NavBar from '../NavBar/MyBiyesadi';
import MatchesNavBar from '../NavBar/Matches';
import ConnectionNavBar from '../NavBar/Connection';
import SearchNavBar from '../NavBar/Search';
import { Images } from '../../utils/Images';
import { UserContext } from '../../utils/context/userContext';
import Requests from "../../utils/Requests/Index"

const LeftSidebar = () => {
  const location = useLocation();
  const { user } = useContext(UserContext);
  const userData = useSelector((state) => state.user.userData);
  const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } });

  const doLogout = async () => {
    try {
      await Requests.Auth.Logout(header);
      localStorage.clear()
      window.location.reload()
    } catch (err) {
      if (err) console.log(err);
    }
  }

  const buildImage = value => {
    if (!value) return Images.NoImage
    return String(value).startsWith('http') ? value : `${process.env.REACT_APP_IMAGE_URL}/matchmaking-service/${value}`
  }

  const name = user?.name || userData?.name || 'My account';
  const profileId = user?.profileId;
  const plan = user?.profileType || userData?.profileType || 'Free';
  const isPaid = plan === 'Paid';
  const avatar = buildImage(user?.profilePicture?.clearImage || userData?.profilePicture);

  const railItems = [
    { to: '/my-dashboard', label: 'Dashboard', icon: userIcon },
    { to: '/matches', label: 'Matches', icon: users },
    { to: '/connection', label: 'Connection', icon: userCheck },
    { to: '/timeline', label: 'Timeline', icon: activity },
    { to: '/search', label: 'Search', icon: search },
  ];

  return (
    <div className="app-sidebar">
      <aside className="sidebar">

        {/* Brand */}
        <div className="sidebar-brand">
          <Link to="/my-dashboard" className="brand-link">
            <span className="brand-logo">
              <img src={Images.Logo} alt="Matchmaking Service" />
            </span>
            <span className="brand-text">
              <b>Matchmaking</b>
              <i>Service</i>
            </span>
          </Link>
        </div>

        {/* Signed in member */}
        <Link to="/my-dashboard/profile" className="sidebar-user">
          <span className="sidebar-user-avatar">
            <img src={avatar} alt={name} />
          </span>
          <span className="sidebar-user-text">
            <b className="text-capitalize">{name}</b>
            <i>{profileId ? `ID: ${profileId}` : 'View my profile'}</i>
          </span>
          <span className={`sidebar-plan ${isPaid ? 'is-paid' : 'is-free'}`}>{plan}</span>
        </Link>

        {/* Navigation */}
        <div className="sidebar-nav">
          <div className="nav-group">

            {/* Icon rail */}
            <nav className="sidebar-rail">
              {railItems.map(item =>
                <NavLink
                  key={item.to}
                  to={item.to}
                  title={item.label}
                  className={({ isActive }) => `icon-box ${isActive ? 'active' : ''}`}
                >
                  <Icon icon={item.icon} size={20} />
                  <span className="rail-tip">{item.label}</span>
                </NavLink>
              )}

              <span className="rail-spacer" />

              <button type="button" className="icon-box danger" onClick={doLogout} title="Logout">
                <Icon icon={logOut} size={20} />
                <span className="rail-tip">Logout</span>
              </button>
            </nav>

            {/* Section links */}
            <div className="nav-items">

              {/* My Biyesadi */}
              {location.pathname.startsWith('/my-dashboard') && <NavBar />}

              {/* Matches */}
              {location.pathname.startsWith('/matches') && <MatchesNavBar />}

              {/* Connection */}
              {location.pathname.startsWith('/connection') && <ConnectionNavBar />}

              {/* Search */}
              {location.pathname.startsWith('/search') && <SearchNavBar />}

            </div>

          </div>
        </div>

        {/* Membership */}
        <div className="sidebar-foot">
          {isPaid ?
            <Link to="/my-dashboard/package" className="foot-card">
              <Icon icon={creditCard} size={17} />
              <span className="foot-card-text">
                <b>My package</b>
                <i>Manage your membership</i>
              </span>
            </Link>
            :
            <Link to="/my-dashboard/package" className="foot-card is-upgrade">
              <Icon icon={zap} size={17} />
              <span className="foot-card-text">
                <b>Upgrade now</b>
                <i>Unlock contact and chat</i>
              </span>
            </Link>
          }
        </div>

      </aside>
    </div>
  );
};

export default LeftSidebar;
